import type { ReactNode } from "react";

type NoDataNoticeProps = {
  title?: string;
  description?: string;
  actions?: ReactNode;
};

export function NoDataNotice({
  title = "Brak danych do wyświetlenia",
  description = "Dodaj nowe dane lub odśwież stronę i spróbuj ponownie.",
  actions,
}: NoDataNoticeProps) {
  return (
    <main className="min-h-screen bg-slate-200 px-6 py-10 text-slate-900 transition-colors dark:bg-neutral-950 dark:text-slate-100">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-6 rounded-[32px] bg-white p-10 text-center shadow-[0_30px_80px_-40px_rgba(15,23,42,0.45)] transition-colors dark:bg-neutral-900/80 dark:shadow-[0_30px_80px_-40px_rgba(0,0,0,0.6)]">
        <h1 className="text-3xl font-semibold tracking-tight">{title}</h1>
        {description ? <p className="text-sm text-slate-600 dark:text-slate-300/80">{description}</p> : null}
        {actions ? <div className="mt-2 flex flex-wrap justify-center gap-3">{actions}</div> : null}
      </div>
    </main>
  );
}
